import { Heading } from "@amzn/storm-ui";

import {
    CardRecommendationContainer,
    CardRecommendationContent,
} from "./styles";

interface CardRecommendationProps {
    recommendation?: string;
    dataTestId: string;
}

export const CardRecommendation: React.FC<CardRecommendationProps> = ({
    recommendation,
    dataTestId,
}) => {
    if (!recommendation) return null;

    return (
        <CardRecommendationContainer
            data-testid={`${dataTestId}-recommendation`}
        >
            <Heading renderAs="h6" color="secondary">
                Why did we suggest this?
            </Heading>
            <CardRecommendationContent>
                {recommendation}
            </CardRecommendationContent>
        </CardRecommendationContainer>
    );
};
